"use strict";
/** Shared TypeScript types for the API layer. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURED_IMAGE_SIZE_ORDER = void 0;
exports.FEATURED_IMAGE_SIZE_ORDER = [
    'medium_large',
    'large',
    'full',
    'medium',
    'thumbnail',
];
//# sourceMappingURL=index.js.map